/**
 * Фильтр валюты
 * @param value Исходное значение
 * @returns Форматированное значение
 */
export default function currencyFilter(value: string): string {
  let curr = "";
  if (value) {
    switch (value.toUpperCase()) {
      case "RUR":
      case "RUB":
      case "810":
        curr = "₽";
        break;
      case "USD":
      case "840":
        curr = "$";
        break;
      case "EUR":
      case "978":
        curr = "€";
        break;
      case "CNY":
        curr = "￥";
        break;
      case "CHF":
      case "756":
        curr = "₣";
        break;
      default:
        curr = value.toUpperCase();
        break;
    }
  }
  return curr;
}
